module.exports = __webpack_public_path__ + "static/assets/65b6f410ffd6298f51257556d32e92de.svg";